import { Divider } from '@chakra-ui/react';
import classes from './RecentPurCard.module.scss';
import { useNavigate } from 'react-router-dom';

const RecentPurCard = ({content}) => {
    const navigate = useNavigate();
    
    const handleClick = () => {
        navigate('/garage?source=auction&tab=purchases');
    };
    
    return (
        <div 
            className={classes.RecentPurCard}
            onClick={handleClick}
            role="button"
            tabIndex="0"
            aria-label={`View purchase details for ${content.name}`}
            style={{ cursor: 'pointer' }}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    handleClick();
                }
            }}
        >
            <div className={classes.IdDiv}>ID: {content.id}</div>

            <div className={classes.NameAndStatus}>
                <div className={classes.NameDiv}>
                    <h3>{content.name}</h3>
                </div>
                <div className={classes.ProcessingDiv}>
                    <p className={classes.status + ' ' + classes[content.status.replace(/\s+/g, '').toLowerCase()]}>
                        <span className={classes.statusDot}>●</span> 
                        <span className={classes.statusText}>
                            {content.status==="Arrived at Destination Port" ? "Arrived at Dst. Port" : content.status}
                        </span>
                    </p>
                </div>
            </div>

            <div className={classes.Info}>
                <div className={classes.InfoContext}>
                    <div className={classes.InfoIconContainer}>
                    <i className="fas fa-gavel"></i>
                    </div>
                    <p>{content.auction}</p>
                </div>
                <div className={classes.InfoContext}>
                    <div className={classes.InfoIconContainer}>
                    <i className="fas fa-tag"></i>
                    </div>
                    <p>Bid No: {content.bidNo.replace(/^No\./, '')}</p>
                </div>
                <div className={classes.InfoContext}>
                    <div className={classes.InfoIconContainer}>
                    <i className="far fa-calendar"></i>
                    </div>
                    <p>{content.date}</p>
                </div>
            </div>
            <Divider orientation='horizontal' />
        </div>
    );
};

export default RecentPurCard;